const orderActionTypes={
    SET_ORDER_STATUS:'order/setOrderStatus',

}

export default orderActionTypes;